import React from 'react';
import Layout from '../layout';
import { Boards } from './Boards';
import ChooseBoard from './ChooseBoard';

export const ChooseBoardPage: React.FC = () => {
  return (
    <Layout components={[<ChooseBoard key="boards-list" />]} />
  );
};

export const BoardPage: React.FC = () => {
  return <Layout components={[<Boards key="boards" />]} />;
};
